import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderSlot as _renderSlot, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 1,
    class: "wrybit-load-error",
    role: "alert"
};
import { markRaw, ref, shallowRef, watch } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WrybitBoundary',
    props: {
        enabled: { type: Boolean },
        screen: {},
        loadShell: { type: Function }
    },
    emits: ["classic", "active", "views"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const shell = shallowRef();
        const failed = ref(false);
        let pending;
        watch(() => props.enabled && shell.value !== undefined, (active) => emit('active', active), { immediate: true });
        function loadDefaultShell() {
            return import(/* webpackChunkName: "wrybit-ui" */ '@/client/wrybit/shell/WrybitShell.vue').then((module) => module.default);
        }
        watch(() => props.enabled, async (enabled) => {
            if (!enabled || shell.value !== undefined) {
                return;
            }
            failed.value = false;
            try {
                pending ??= (props.loadShell ?? loadDefaultShell)();
                shell.value = markRaw(await pending);
            }
            catch {
                pending = undefined;
                if (props.enabled && !failed.value) {
                    failed.value = true;
                    emit('classic');
                }
            }
        }, { immediate: true });
        return (_ctx, _cache) => {
            const _directive_i18n = _resolveDirective("i18n");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (__props.enabled && shell.value !== undefined)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(shell.value), {
                        key: 0,
                        screen: __props.screen,
                        onClassic: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('classic'))),
                        onViews: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('views', $event)))
                    }, null, 40, ["screen"]))
                    : _createCommentVNode("", true),
                (failed.value)
                    ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_1, [...(_cache[2] || (_cache[2] = [
                            _createTextVNode("Wrybit could not be loaded. The classic interface is available.", -1)
                        ]))])), [
                        [_directive_i18n]
                    ])
                    : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default")
            ], 64));
        };
    }
});
